const targetDate = new Date(2025, 10, 28);

const timerElements = document.querySelectorAll(".timer__cell");

const timerInterval = setInterval(() => {
  const currentDate = new Date();
  const timeDiff = targetDate - currentDate;

  if (timeDiff < 0) {
    timerElements.forEach((el) => el.textContent = "00");
    clearInterval(timerInterval);
    return;
  }

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

  const timer = [
    days < 10 ? `0${days}` : days,
    hours < 10 ? `0${hours}` : hours,
    minutes < 10 ? `0${minutes}` : minutes,
    seconds < 10 ? `0${seconds}` : seconds,
  ]

  timerElements.forEach((el, index) => el.textContent = timer[index]);
}, 1000);